import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";


const AboutNews = ({ homeData, NewsData }) => {

  const { t,i18n } = useTranslation("News");

  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    if (homeData && NewsData) {
      setIsLoading(false);
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-visible");
          } else {
            entry.target.classList.remove("animate-visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    const sections = document.querySelectorAll(".animate-section");
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, [homeData, NewsData]);

  const homeTitle = homeData


  return (
    <>
      <div id="news"></div>
      <div className="main-container bg-[#fff] relative mx-auto py-16">
        <div className="w-[83%] scale-95 mx-auto">
          {/* Header Section */}
    <div className="text-center flex items-center flex-col">
        <span className="text-[25px] text_bold_Bukra leading-[45.5px] text-[#0d6b70] block animate-section opacity-0 transition-opacity duration-1000">
          {homeTitle?.data.sections[3]?.title}
        </span>
        <div className="lg:w-[776px] max-sm:w-[88%] text-center justify-start  text-base font-medium  text-[#667680] mt-4">  
          {homeTitle?.data.sections[3]?.Posts[0]?.description}
        </div>
      </div>

          {/* News Section */}
          <div className="flex flex-wrap md:flex-nowrap gap-6 justify-between mt-8">
            {/* News Cards */}
            {NewsData?.data?.slice(0, 3).map((news, index) => {
              let formattedDate = "تاريخ غير متوفر";
              try {
                formattedDate = new Date(
                  news.date.split("-").reverse().join("-")
                ).toLocaleDateString(i18n.language === "ar" ? "ar-EG" : "en-US", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                });
              } catch (error) {
                console.error("خطأ في تحويل التاريخ:", error);
              }



              return (

              <Link
                to={`/stats/${news.id}`}
                key={index}
                className="flex flex-col sm:w-1/3 py-3 overflow-hidden group relative animate-section opacity-0 transition-opacity duration-1000"
              >
                {/* Hover Effect */}
                <div className="absolute inset-0 border-b-2 border-transparent">
                  <div className="absolute top-[100%] -start-[100%] w-full h-1 bg-gradient-to-r from-[#0d6b70] via-[#0d6b70] to-[#0d6b70] group-hover:-translate-x-full transition-all duration-500"></div>
                </div>
                {/* News Image */}
                <div className="rounded-[16px] overflow-hidden">
                  <div
                    className="h-[303px] bg-cover bg-center transition-transform duration-500 group-hover:scale-125"
                    style={{ backgroundImage: `url(${news?.image[0]?.original || "/Rectangle.png"})` }}
                  ></div>
                </div>
                {/* Card Content */}
                <div className="p-4 flex flex-col gap-4">
                  <span className="text-[18px] font-bold group-hover:text-[#0d6b70] transition-transform duration-500 md:tracking-wide leading-[35px] text-[#0d6b70] line-clamp-2 29LT_Bukra">
                    {news.name}
                  </span>
                  <span className="text-[15px] font-normal leading-[28px] text-[#667680] line-clamp-3">
                    {news.description}
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="text-[16px] text_small_Bukra font-semibold text-[#667680]">
                    {formattedDate}
                    </span>
                    {/* <span className="text-[16px] font-medium text-[#e7edf2]">•</span>
                    <span className="text-[16px] font-semibold text-[#0d6b70]">
                      {news.type?.name}
                    </span> */}
                  </div>
                </div>
              </Link>
              );
            })}
          </div>

          {/* View All News Button */}
          <div className="flex justify-center mt-8 animate-section opacity-0 transition-opacity duration-1000">
            <Link
              to={"/news"}
              className="px-12 py-3 29LT_Bukra border border-[#0d6b70] text-[#0d6b70] hover:bg-[#0d6b70] hover:text-white hover:scale-90 rounded-full text-[14px] font-normal transition-all duration-500"
            >
              {t('Browse')}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutNews;
